import { useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

import Global from '../../../../../../store/global-selectors';

const usePudoServicesAvailableForSeller = (shouldLoadPudoData = false) => {
  const [loading, setLoading] = useAsyncSafeState(true);
  const [pudoServices, setPudoServices] = useAsyncSafeState([]);
  const allServices = useSelector(Global.selectSellerServices);
  useEffect(() => {
    if (!shouldLoadPudoData) {
      setLoading(false);
      return;
    }
    axios
      .get('/seller/shippingservices/supportsservicepoints')
      .then((response) => {
        const validServices = response.data.map((s) => s.serviceId);
        const goodServices = allServices
          .filter((service) => !service?.features?.supportsInternationalShipping)
          .filter((service) => validServices.includes(service.serviceId));
        setLoading(false);
        setPudoServices(goodServices);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [setLoading, setPudoServices, allServices, shouldLoadPudoData]);

  return {
    loading,
    pudoServices,
  };
};

export default usePudoServicesAvailableForSeller;
